import React from "react";

function Loading({pastDelay}) {
  return pastDelay ? <div>Loading...</div> : null;
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/LoadingComponent.js